import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SignUpComponent } from './sign-up/sign-up.component';
import { HomeScriptComponent } from './home-script/home-script.component';
import { SalesScriptComponent } from './sales-script/sales-script.component';
import { PricingScriptComponent } from './pricing-script/pricing-script.component';
import { AboutScriptComponent } from './about-script/about-script.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { ResetPasswordLinkComponent } from './reset-password-link/reset-password-link.component';
import { VerifyAccountComponent } from './verify-account/verify-account.component';
import { NotAuthGuardService } from './not-auth-guard.service';
import { PrivacyComponent } from './privacy/privacy.component';
import { TermsComponent } from './terms/terms.component';
import { SignupBillingComponent } from './signup-billing/signup-billing.component';
import { VerifyEmailComponent } from './verify-email/verify-email.component';

const authRoutes: Routes = [
  {
    path: 'reset-password',
    component: ResetPasswordLinkComponent,
    canActivate: [NotAuthGuardService]
  },
  {
    path: 'verify-email/:token',
    component: VerifyEmailComponent,
    canActivate: []
  },
  { path: 'home-script', component: HomeScriptComponent, canActivate: [NotAuthGuardService] },
  { path: 'sales-script', component: SalesScriptComponent, canActivate: [NotAuthGuardService] },
  { path: 'pricing', component: PricingScriptComponent, canActivate: [NotAuthGuardService] },
  { path: 'about', component: AboutScriptComponent, canActivate: [NotAuthGuardService] },
  { path: 'contact-us', component: ContactUsComponent },
  { path: 'signup', component: SignUpComponent, canActivate: [NotAuthGuardService] },
  { path: 'verify-account/:token', component: VerifyAccountComponent, canActivate: [NotAuthGuardService] },
  { path: 'signup-billing/:annualFee', component: SignupBillingComponent, canActivate: [NotAuthGuardService] },
  { path: 'privacy', component: PrivacyComponent},
  { path: 'terms', component: TermsComponent},
];

@NgModule({
  imports: [RouterModule.forChild(authRoutes)],
  exports: [RouterModule]
})
export class AuthRoutingModule { }
